import styled from 'styled-components';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import { Box } from '@lessonnine/design-system.lib';

export const FooterContainer = styled(Box)`
  background-color: ${({ theme }) => theme.color.surface.layer.background};
  border-top: none;
  margin: 0 auto;
  width: fit-content;
  z-index: 30;

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => theme.color.surface.container.background};
  }
`;
